// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WciaF","Footer__logo":"Footer_Footer__logo__o+SoP","Footer__social":"Footer_Footer__social__v+EpN"};